
import { Row, Col } from 'react-bootstrap';
import {ArrowRightCircleFill} from 'react-bootstrap-icons';
import CentralLink from './CentralLink.js';


function formatString(input) {
  // Check the length of the string
  if (input.length <= 10) {
    return input;
  } else {
    // If the length is greater than x, format as per requirements
    return input.substring(0, 4) + '...' + input.substring(input.length - 4);
  }
}

function BreadcrumbComponent({ crumbMode = "DATAEX_BASINS_STATIONS", riverBasinName, subUnitName, mgmtCatchmentName, operCatchmentName, waterBodyName, leafText = null }) {

	// const riverBasinNameShortText = formatString(riverBasinName);
	// const mgmtCatchmentNameShortText = formatString(mgmtCatchmentName);
	// const operCatchmentNameShortText = formatString(operCatchmentName);
	// const waterBodyNameShortText = formatString(waterBodyName);

	const basinLink = riverBasinName ? <span key="crumb_basin"><CentralLink to={"/data-explorer/basins/" + riverBasinName} dottedUnderline>{riverBasinName}</CentralLink></span> : null;
	const subUnitLink = riverBasinName && subUnitName ? <span key="crumb_basin"><CentralLink to={"/data-explorer/river-sub-units/" + subUnitName} dottedUnderline>{subUnitName}</CentralLink></span> : null;
	const mgmtLink = riverBasinName && mgmtCatchmentName ? <span key="crumb_mgmt"><CentralLink to={"/data-explorer/management-catchments/" + mgmtCatchmentName} dottedUnderline>{mgmtCatchmentName}</CentralLink></span> : null;
	const operLink = riverBasinName && mgmtCatchmentName && operCatchmentName ? <span key="crumb_oper"><CentralLink to={"/data-explorer/operational-catchments/" + operCatchmentName} dottedUnderline>{operCatchmentName}</CentralLink></span> : null;
	const waterBodyLink = riverBasinName && (subUnitName || (mgmtCatchmentName && operCatchmentName)) && waterBodyName ? <span key="crumb_wb"><CentralLink to={"/data-explorer/water-bodies/" + waterBodyName} dottedUnderline>{waterBodyName}</CentralLink></span> : null;

	let crumbs = [];

	switch(crumbMode) {
		case "DATAEX_BASINS_STATIONS":
		default:
			crumbs.push(<span key="crumb_all_basin"><CentralLink to={"/data-explorer/basins"} dottedUnderline>River Basins</CentralLink></span>);
			basinLink && crumbs.push(basinLink);
			subUnitLink && crumbs.push(subUnitLink);
			mgmtLink && crumbs.push(mgmtLink);
			operLink && crumbs.push(operLink);
			waterBodyLink && crumbs.push(waterBodyLink);
			break;
	}


	return <Row>
		<Col xs={12} className="d-none d-md-block bg-dark text-white header-bold" >
			{crumbs.map(function(crumb, ix) {
				let rets = [];
				if(ix) {
					rets.push(<span key={"sep_"+ix}> <ArrowRightCircleFill /> </span>);
				}
				rets.push(crumb);

				// last crum? add the leaf
				if(ix === (crumbs.length-1) && leafText) {
					rets.push(<span key={"sep_l"+ix}> <ArrowRightCircleFill /> </span>);
					rets.push(<span key="leaftext">{leafText}</span>);
				}
				return rets;
			})}
		</Col>
		<Col xs={12} className="d-md-none bg-dark text-white header-bold" style={{fontSize: "0.8em"}}>
			{crumbs.map(function(crumb, ix) {
				if(ix === 0) {
					return crumb;
				}
				if(ix === (crumbs.length-1)) {
					return [
						crumbs.length > 2 ? <span key={"sep_p"+ix}> <ArrowRightCircleFill /> </span> : null,
						crumbs.length > 2 ? <span key={"sep_x"+ix}>. . .</span> : null,
						<span key={"sep_a"+ix}> <ArrowRightCircleFill /> </span>,
						crumb,
						leafText ? <span key={"sep_l"+ix}> <ArrowRightCircleFill /> </span> : null,
						leafText ? <span key="leaftext">{leafText}</span> : null
					];
				}
				return null;
			})}
		</Col>
		{/*<Col xs={12} className="d-md-none bg-dark text-white header-bold" style={{fontSize: "0.8em"}}>{riverBasinNameShortText} // {mgmtCatchmentNameShortText} // {operCatchmentNameShortText} // {waterBodyNameShortText}</Col>*/}
	</Row>;
}


export default BreadcrumbComponent;